import { CommitmentsScenariosService } from '@festina/life-general-types/life/services/CommitmentsScenariosService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

const method =
  CommitmentsScenariosService.commitmentScenarioVersionServicePostCreateEntity
type MethodParam = Parameters<typeof method>[0]

export const useSubmitScenario = ({
  tenantId,
  ownerId,
}: {
  tenantId: string
  ownerId: string
}) =>
  useFestinaMutation({
    component: 'life',
    roles:
      CommitmentsScenariosService.commitmentScenarioVersionServicePostCreateEntity_roles,
    isScenario: false,
    mutateFunction: async (
      arg: Except<MethodParam, 'ownerId' | 'xTenantId'>,
    ) => {
      await method({ xTenantId: tenantId, ownerId, ...arg })
    },
  })
